/*eslint-disable*/
import React, { Component } from "react";
import SideLink from './sidelink';
import AsideDropDown from './asideDropdown';
// import { RoleId } from '../constantKeys/keys'
class AsideBar extends Component {

    render() {
        // console.log('roleIDSSS', RoleId)
        let roleKey = localStorage.getItem('roleId')
        let imgIcon = "";
        let imgIconWidth = "";
        let customerNo = Number(localStorage.getItem("customerNo"))
        console.log(customerNo,"customerNo")
        switch (customerNo) {
            case 1371:
                imgIcon = "assets/img/MLOGO_VELV.JPG";
                imgIconWidth = "60%";
                break;
            case 353:
                imgIcon = "assets/img/sahara.jpg";
                imgIconWidth = "60%";
                break;
            default:
                imgIcon = "assets/img/logo.png";
                imgIconWidth = "60%";
                break;
        }
        return (
            <React.Fragment>
                <div id="sidebars">
                    <aside id="asidebar" className="sidenav smallSiderbar">
                        <div className="img-thumbnail">
                            <img
                                src={imgIcon}
                                alt="logo"
                                // className="mr-5"
                                style={{ objectFit: 'contain', width: '250px', display: 'block', padding:'20px' }}
                            />
                            {/* <img src={+localStorage.getItem('customerNo') == 1371 ? 'assets/img/MLOGO_VELV.JPG' : 'assets/img/logo.png'} alt=""
                                className={+localStorage.getItem('customerNo') == 1371 ? "padding-15 sidelogo" : "sidelogo p-0"} style={{ width: '230px', objectFit: 'contain' }}
                            /> */}
                        </div>
                        {localStorage.getItem('role').toLowerCase() == 'approver' ?
                            <>
                                <SideLink imgLink="assets/svg/approvals.svg" linkTo="/approvals" linkName="Approvals" />
                            </>
                            :
                            <>
                                <SideLink Exact={true} imgLink="assets/svg/dashboard.svg" linkTo="/" linkName="Dashboard" />
                                <SideLink imgLink="assets/svg/jobcards.svg" linkTo="/jobcard" linkName="Jobcard" />
                                <SideLink imgLink="assets/svg/documents.svg" linkTo="/document" linkName="Documents" />
                                <SideLink imgLink="assets/svg/checklist.svg" linkTo="/checklist" linkName="Checklist" />
                                {localStorage.getItem('role').toLowerCase() == 'user' || localStorage.getItem('role').toLowerCase() == 'operational user' ?
                                    null
                                    :
                                    <>
                                        <SideLink imgLink="assets/svg/approvals.svg" linkTo="/approvals" linkName="Approvals" />
                                        <AsideDropDown />
                                    </>
                                }

                            </>
                        }
                        {/*                         
                         */}
                    </aside>
                </div>
            </React.Fragment>
        )
    }
}

export default AsideBar;